import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import Icon from "./Icons";
const base64 = require('js-base64').Base64;

const LocalApiUrl = "/api";

const Register = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    email: "", password: "", firstName: "", lastName: "", city: "",
  });
  const [error,   setError]   = useState(null);
  const [loading, setLoading] = useState(false);

  const encryptUserId = (userId) => {
    const key = process.env.REACT_APP_SECRET_KEY || "Yq3t6v9y";
    const encrypted = CryptoJS.AES.encrypt(userId.toString(), key).toString();
    return base64.encode(encrypted, true);
  };

  const handleChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(`${LocalApiUrl}/user/register`, user);
      const enc = encryptUserId(res.data.userId);
      localStorage.setItem("userId",          res.data.userId);
      localStorage.setItem("encryptedUserId", enc);
      navigate("/login");
    } catch (err) {
      if (err.response?.status === 409) {
        setError("An account with this email already exists. Please sign in.");
      } else {
        setError("Something went wrong. Use a valid email and a strong password.");
      }
    } finally {
      setLoading(false);
    }
  };

  const field = (label, name, type = "text", placeholder = "") => (
    <div className="flex flex-col gap-1.5">
      <label className="text-cream-dim text-xs font-medium uppercase tracking-wider">
        {label}
      </label>
      <input
        type={type}
        name={name}
        value={user[name]}
        onChange={handleChange}
        placeholder={placeholder}
        className="sc-input"
        required={name !== "city"}
        minLength={name === "password" ? 8 : undefined}
      />
    </div>
  );

  return (
    <div className="grid min-h-[calc(100vh-4rem)] lg:grid-cols-[0.8fr_1.2fr]">
      <div className="hidden border-r border-ink-border bg-gradient-to-br from-[#17252e] via-ink-surface to-ink-base p-12 lg:flex lg:flex-col lg:justify-between">
        <Link to="/" className="inline-flex w-fit items-center gap-2 text-sm text-cream-muted no-underline transition-colors hover:text-cream"><Icon name="arrow" className="rotate-180" size={15} /> Back home</Link>
        <div>
          <p className="sc-kicker mb-4">A better reading habit</p>
          <h2 className="font-serif text-5xl leading-[1.02] tracking-[-0.035em] text-cream">Keep the books.<br /><span className="italic text-gold">Keep what mattered.</span></h2>
          <div className="mt-9 space-y-4">
            {["Track books without busywork", "Get recommendations built around you", "Revisit stories through character chat"].map((item, index) => (
              <div key={item} className="flex items-center gap-3 text-sm text-cream-dim"><span className="flex h-6 w-6 items-center justify-center rounded-full bg-gold/10 text-[10px] font-bold text-gold">{index + 1}</span>{item}</div>
            ))}
          </div>
        </div>
        <p className="text-xs text-cream-muted">Free forever for your personal library.</p>
      </div>

      <div className="flex items-center justify-center px-5 py-14 sm:px-10">
        <div className="relative w-full max-w-lg">
          <div className="mb-8">
            <p className="sc-kicker mb-3">Join StoryChats</p>
            <h1 className="font-serif text-4xl font-semibold text-cream tracking-[-0.03em]">Create your reading home.</h1>
            <p className="mt-2 text-sm text-cream-muted">Start with a few details. Add your first book next.</p>
          </div>

          <div className="sc-panel p-6 sm:p-8">
          {error && (
            <div className="bg-crimson/10 border border-crimson/30 text-crimson-light rounded-lg px-4 py-3 text-sm mb-5">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            {field("Email",      "email",     "email",    "you@example.com")}
            {field("Password",   "password",  "password", "••••••••")}
            <div className="grid grid-cols-2 gap-3">
              {field("First name", "firstName", "text", "Ada")}
              {field("Last name",  "lastName",  "text", "Lovelace")}
            </div>
            {field("City (optional)", "city", "text", "London")}

            <button
              type="submit"
              disabled={loading}
              className="sc-btn-gold py-3 text-sm mt-1 disabled:opacity-50"
            >
              {loading ? "Creating account…" : <><span>Create my library</span><Icon name="arrow" size={15} /></>}
            </button>
          </form>
        </div>

        <p className="text-center text-cream-muted text-sm mt-6">
          Already have an account?{" "}
          <Link to="/login" className="text-gold no-underline hover:text-gold-light">
            Sign in
          </Link>
        </p>
      </div>
      </div>
    </div>
  );
};

export default Register;
